import React from "react";

export const COMMON_ALT = "Eazy Gaming top-notch slot games";
export const COMMON_LOADING = 1500;
export const WEB_PATH = "https://egslot.net/";
export const WEB = "https://egslot.net/";
